export const PRINT_DEFAULT_VALUES = {
    address: {
        JUBAIL: "Branch – C.R.: 2055135994 Al Jubail 31951 P.O. Box 2594 King Abdullah Road Blue Palace Tower 1st Kingdom of Saudi Arabia",
        YANBU: "P.O. Box 1773, Yanbu Al-Balad District – King Abdulaziz Road, Yanbu 46424 – 6903, Kingdom of Saudi Arabia.",
    },
    arabicAddress: {
        JUBAIL: "فرع – س.ت: ٢٠٥٥١٣٥٩٩٤ الجبيل ٣١٩٥١  صندوق البريد ٢٥٩٤ طريق الملك عبدالله برج بلو بالاس ١ المملكة العربية السعودية",
        YANBU: "ص.ب-1773- ﺣﻲ ﻳﻨﺒﻊ اﻟﺒﻠﺪ - ﻃﺮﻳﻖ اﻟﻤﻠﻚ ﻋﺒﺪ اﻟﻌﺰﻳﺰ، ﻳﻨﺒﻊ 46424 - 6903. اﻟﻤﻤﻠﻜﺔ اﻟﻌﺮﺑﻴﺔ اﻟﺴﻌﻮدﻳﺔ",
    },
    mail: "info@arengineeringksa.com",
    crNumber: "2055135994",
    vatNumber: "301153562600003",
};

export type Branches = "YANBU" | "JUBAIL";
